import React from "react";
import { TableHead } from "@mui/material";

const DSTableHead = (props: React.ComponentProps<typeof TableHead>) => {
  return <TableHead {...props} />;
};

export default DSTableHead;
